<template>
  <section class="job-summary">
    <div class="job-summary__content">

      <div class="job-summary__facts">
        <span>{{ associate?.role?.name || '-' }}</span>
        <span>{{ employment || '-' }}</span>
        <span>{{ paymentMethod }}</span>
        <span>{{ scheduleType }}</span>
        <span><strong>Training:</strong> {{ associate.is_in_training_period ? 'Active' : 'Inactive' }}</span>
        <span><strong>Attendance:</strong> {{ attendanceRate }}</span>
      </div>
    </div>

    <a-tag class="job-summary__status" :color="associateStatus.color">
      {{ associateStatus.title }}
    </a-tag>
  </section>
</template>

<script>
import { Tag } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'
import { PAYMENT_METHOD } from '@/store/modules/payment/constants'
import { SCHEDULED_TYPE } from '@/store/modules/profile/constants'
import { getAssociateStatus } from '@/store/modules/profile/utils'
import { formatEmployment } from '@/modules/profile/utils/profile-formatters'
import SectionDivider from '@/components/ui/section-divider.vue'

const { mapState: profileState } = createNamespacedHelpers('profile')

export default {
  components: {
    'a-tag': Tag,
    'section-divider': SectionDivider
  },
  computed: {
    ...profileState({
      associate: state => state.associate
    }),

    associateStatus() {
      return getAssociateStatus(
        this.associate.work_status,
        this.associate.termination?.type
      )
    },

    employment() {
      return formatEmployment(this.associate.payment_info)
    },

    paymentMethod() {
      return PAYMENT_METHOD[this.associate.payment_info?.method] || '-'
    },

    scheduleType() {
      return SCHEDULED_TYPE[this.associate.schedule_type] || '-'
    },

    attendanceRate() {
      return typeof this.associate.attendance_rate === 'number'
        ? `${(this.associate.attendance_rate * 100).toFixed(0)}%`
        : '-'
    }
  }
}
</script>

<style scoped>
.job-summary {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px;
  border: 1px solid var(--border-color-base);
  border-radius: var(--border-radius);
  background: var(--bg-card);
}

.job-summary__content {
  flex: 1;
  min-width: 0;
}

.job-summary__facts {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  color: var(--text-color);
}

.job-summary__facts span:not(:last-child)::after {
  content: '·';
  margin-left: 16px;
  color: var(--text-color-secondary);
}

.job-summary__status {
  flex: 0 0 auto;
  margin: 0;
}

@media screen and (max-width: 640px) {
  .job-summary {
    flex-wrap: wrap;
  }

  .job-summary__content {
    flex-basis: 100%;
  }

  .job-summary__status {
    order: -1;
    margin-left: auto;
  }

  .job-summary__facts {
    flex-direction: column;
  }

  .job-summary__facts span::after {
    display: none;
  }
}
</style>
